export const ARTICLES = [
  {
    url: "https://blog.mintology.app/how-nfts-revolutionize-travel-lifestyle-industries/",
    image: "/images/insights_001.webp",
    title: "How Mintology Can Revolutionize Industries",
    description:
      "Changing landscape and changing age demographics means changing business needs. See how Mintology can revolutionize your industry.",
  },
  {
    url: "https://blog.mintology.app/nfts-reinventing-ticketing/",
    image: "/images/insights_002x.webp",
    title: "Events & NFTs!",
    description:
      "A lot of our clients use NFTs to increase their presence at events or to drive more sponsors and engagement - at their own conferences.",
  },
  {
    url: "https://blog.mintology.app/nfts-future-of-authentication/",
    image: "/images/insights_003.webp",
    title: "NFT Authorize for Enterprises",
    description:
      "Using our APIs, Entreprises and SMEs can use simple token gating to authorize access into events, doors, discounts, VIP experiences and more.",
  },
  {
    url: "https://blog.mintology.app/inspiring-loyalty-gaming-mintology-solutions-station-casinos/",
    image: "/images/insights_004.webp",
    title: "Integration in the real world",
    description:
      "With our simple APIs, any developer can get started with a few lines of code. See how one client rolled out over 1.5m NFTs to over 75,000 people aged 50-70 years old.",
  },
];

export const WALLETS_ARTICLES = [
  {
    url: "https://blog.mintology.app/web2-brands-nft-adoption-wallet-free-gasless/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/03/1-How-Mintology-Helps-Web2-Brands-1.jpg?fit=1024%2C684&ssl=1",
    title: "Industry Transformations",
    description:
      "Discover how businesses are leveraging Mintology’s managed wallets to unlock new revenue streams and streamline digital asset strategies.",
  },
  {
    url: "https://blog.mintology.app/mastercard-nft-event-engagement-case-study/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2023/08/Events-WL.png?fit=1024%2C683&ssl=1",
    title: "Event Engagement with NFTs",
    description:
      "Learn how organizations integrate custodial wallets into event experiences to boost attendee interaction and sponsor value.",
  },
  {
    url: "https://blog.mintology.app/digital-products-nft-wallet-safety-beginners-guide/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/04/Apr-4-2025-IG-Mintology.jpg?fit=1024%2C649&ssl=1",
    title: "Enterprise Token Gating",
    description:
      "See how enterprises and SMEs use our wallet APIs for secure access control—enabling VIP events, discounts, and more with ease.",
  },
  {
    url: "https://blog.mintology.app/station-casinos-nft-customer-loyalty-program-case-study/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2023/07/Casino-WL.png?fit=1024%2C683&ssl=1",
    title: "Real‑World Deployments",
    description:
      "Explore a case study where a client issued over 1.5 million NFTs to 75,000+ users aged 50–70 through seamless wallet integration.",
  },
];

export const TOKENIZATION_ARTICLES = [
  {
    url: "https://blog.mintology.app/nft-ticketing-secure-event-tickets/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/04/Apr-9-2025-IG-Mintology.jpg?fit=1024%2C649&ssl=1",
    title: "Art & Collectibles: Authenticity and Provenance",
    description:
      "Learn how NFTs authenticate digital artworks, ensuring buyers can trace their origin and ownership, effectively combating counterfeiting.​",
  },
  {
    url: "https://blog.mintology.app/mintology-blockchain-digital-ownership-digital-products-brands/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/04/Apr-7-2025-IG-Mintology.jpg?fit=1024%2C649&ssl=1",
    title: "Fashion: Enhancing Customer Engagement",
    description:
      "Discover how fashion brands integrate NFTs with NFC chips in products, offering customers exclusive digital content and experiences, creating new revenue streams.​",
  },
  {
    url: "https://blog.mintology.app/web2-brands-monetizing-digital-products-frictionless-nfts/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/03/HowbrandsarewinningwithNFTs-1.jpg?fit=1024%2C649&ssl=1",
    title: "Music & Entertainment: Royalties and Fan Interaction",
    description:
      "See how musicians utilize NFTs to manage royalties and engage fans by offering unique digital collectibles and experiences, ensuring transparent artist compensation.​",
  },
  {
    url: "https://blog.mintology.app/digital-ownership-authenticity-nfts-mintology/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/04/image-17.png?fit=1024%2C649&ssl=1",
    title: "Luxury Goods: Combating Counterfeiting",
    description:
      "Find out how luxury brands adopt NFTs to authenticate products, providing customers with verifiable ownership records and protecting against counterfeit items.",
  },
];

export const TOKENGATING_ARTICLES = [
  {
    url: "https://blog.mintology.app/mintology-blockchain-digital-ownership-digital-products-brands",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/04/Apr-7-2025-IG-Mintology.jpg?fit=1024%2C649&ssl=1",
    title: "How Digital Proof of Ownership is Enhancing Brand Trust",
    description:
      "Learn how token gating can offer VIP access to content, products, or events, enhancing brand trust and customer engagement.",
  },
  {
    url: "https://blog.mintology.app/nft-ticketing-secure-event-tickets/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/04/Apr-9-2025-IG-Mintology.jpg?fit=1024%2C649&ssl=1",
    title: "Secure Ticketing Solutions For Event Access",
    description:
      "Discover how brands are leveraging NFTs to boost their presence at events, attract more sponsors, and increase engagement at conferences. ​",
  },
  {
    url: "https://blog.mintology.app/web2-brands-monetizing-digital-products-frictionless-nfts/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/04/Apr-4-2025-IG-Mintology.jpg?fit=1024%2C649&ssl=1",
    title: "NFT Wallets and Security",
    description:
      "Learn how you can utilize simple token gating solutions, from authorizing access to events, doors, discounts, and VIP experiences to showcasing real-world security applications of token gating technology. ​",
  },
];

export const GENERATIVE_NFTS_ARTICLES = [
  {
    url: "https://blog.mintology.app/web2-brands-monetizing-digital-products-frictionless-nfts/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/03/HowbrandsarewinningwithNFTs-1.jpg?fit=1024%2C649&ssl=1",
    title: "Art & Collectibles",
    description:
      "Learn how generative NFTs and digital products enable creators to produce vast collections of unique pieces algorithmically, enhancing creativity and offering collectors a diverse range of artworks.​",
  },
  {
    url: "https://blog.mintology.app/why-nfts-make-better-memberships/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2024/03/NFT-NYC-interactive-world.jpg?fit=1024%2C684&ssl=1",
    title: "Gaming",
    description:
      "In the gaming world, generative NFTs are redefining player engagement by introducing unique, algorithmically generated in-game assets. Discover how this has changed gaming communities globally.​",
  },
  {
    url: "https://blog.mintology.app/nft-loyalty-programs-monetization/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/03/1-1.jpg?fit=1024%2C649&ssl=1",
    title: "Fashion",
    description:
      "Find out how the fashion industry is embracing generative NFTs to create exclusive digital wearables and accessories, bringing consumers personalized fashion experiences and new avenues for brand interaction and loyalty.​",
  },
  {
    url: "https://blog.mintology.app/nike-swoosh-reimagining-co-creation-in-web3-age/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2024/01/nike-dot-swoosh.jpg?fit=1024%2C684&ssl=1",
    title: "Community Tokens",
    description:
      "Generative NFTs serve as dynamic community tokens, providing members with unique digital identities and access to exclusive content or events. Explore how this fosters a sense of belonging and enhances community engagement.​​",
  },
];

export const CONTRACT_MANAGEMENT_ARTICLES = [
  {
    url: "https://blog.mintology.app/digital-products-nfts-customer-retention-loyalty-programs/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/04/digital-collectibles.jpg?fit=1024%2C649&ssl=1",
    title: "Art & Collectibles",
    description:
      "Learn how artists are deploying on‑chain provenance to launch unique art series that boost collector trust and drive secondary‑market value.​",
  },
  {
    url: "https://blog.mintology.app/nft-loyalty-programs-monetization/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/03/1-1.jpg?fit=1024%2C649&ssl=1",
    title: "Gaming",
    description:
      "Discover how game studios automate in‑game asset ownership and peer‑to‑peer trading, creating vibrant, player‑driven economies.​",
  },
  {
    url: "https://blog.mintology.app/web2-brands-monetizing-digital-products-frictionless-nfts/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/03/HowbrandsarewinningwithNFTs-1.jpg?fit=1024%2C649&ssl=1",
    title: "Fashion",
    description:
      "Read how leading brands issue limited‑edition digital wearables and authenticate luxury items with tokenized certificates.​",
  },
  {
    url: "https://blog.mintology.app/nft-ticketing-secure-event-tickets/",
    image:
      "https://i0.wp.com/blog.mintology.app/wp-content/uploads/2025/04/Apr-9-2025-IG-Mintology.jpg?fit=1024%2C649&ssl=1",
    title: "Community Tokens",
    description:
      "Explore how organizations grant membership, governance, and event access via smart‑contract tokens.​​",
  },
];
